module.exports = __webpack_public_path__ + "media/styles/images/svg/plus-gray-7e13f10adfb4c0cc9218547da034e512.svg";